import {
	IconCheckOutline18 as Check,
	IconCircleCheckOutline18 as CheckCircle2,
	IconCircleDashedOutline18 as Circle,
	IconCircleDashedOutline18 as CircleDot,
	IconClockOutline18 as Clock,
} from "nucleo-ui-outline-18"

import type { FeedbackState } from "@productlane/db"
import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useThreadsFilterState } from "../threads-filter-state"

const STATUSES: FeedbackState[] = ["NEW", "PROCESSED", "COMPLETED", "SNOOZED"]

export const StatusNaming: Record<FeedbackState, string> = {
	NEW: "Open",
	PROCESSED: "Done",
	COMPLETED: "Close loop",
	SNOOZED: "Snoozed",
	UNSNOOZED: "Open",
}

export const StatusIcons: Record<FeedbackState, typeof Circle> = {
	NEW: Circle,
	PROCESSED: CheckCircle2,
	COMPLETED: CheckCircle2,
	SNOOZED: Clock,
	UNSNOOZED: CircleDot,
}

export function StatusFilterItems({ onSelect }: SharedFilterItemsProps) {
	const {
		statuses: selectedStatuses,
		addStatus,
		removeStatus,
	} = useThreadsFilterState()

	return (
		<>
			{STATUSES.map((status) => {
				const Icon = StatusIcons[status]
				return (
					<CommandItem
						onSelect={() => {
							if (selectedStatuses.includes(status)) {
								removeStatus(status)
							} else {
								addStatus(status)
							}
							onSelect()
						}}
						key={status}
						Icon={Icon}
					>
						<div className="flex w-full items-center gap-2">
							<span className="flex-1 truncate">{StatusNaming[status]}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": selectedStatuses.includes(status),
									"opacity-0": !selectedStatuses.includes(status),
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
